import Image from "next/image";
import { VFC } from "react";

import { userLinkIcons } from "components/icons";

import { CurrentUser } from "lib/type";

type UserDataProsp = {
  author: CurrentUser;
};

const UserData: VFC<UserDataProsp> = ({ author }) => {
  if (!author) return <p>ユーザー情報の取得に失敗しました。</p>;

  const { links, avatar, name, color, followerCount, totalLikeCount, bio } =
    author;

  return (
    <section
      className="border-l-[0.5rem] border-solid p-4 md:container md:after:clear-both md:after:block"
      style={{ borderColor: color }}
    >
      <div className="flex md:block">
        <div className="nextimg mr-4 h-36 w-36 flex-shrink-0 rounded-lg md:float-left md:block">
          <Image
            src={avatar || "/default.svg"}
            alt={name || ""}
            width="100%"
            height="100%"
            layout="responsive"
            objectFit="cover"
            priority
            className="rounded-lg"
          />
        </div>
        <div>
          <h1 className="mb-2 justify-start text-xl md:leading-none">{name}</h1>
          <p className="md:float-left md:mr-4">
            フォロワー数
            <span className="ml-1 text-lg font-bold">
              {followerCount < 0 ? 0 : followerCount}
            </span>
          </p>
          <p>
            総いいね数
            <span className="ml-1 text-lg font-bold">
              {totalLikeCount < 0 ? 0 : totalLikeCount}
            </span>
          </p>
          {links && links.length > 0 && (
            <ul className="mt-2 flex items-center space-x-4 leading-none">
              {userLinkIcons(links)}
            </ul>
          )}
        </div>
      </div>
      {bio && <p className="mt-2 whitespace-pre-wrap">{bio}</p>}
    </section>
  );
};

export default UserData;
